import Typography from "@mui/material/Typography";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

import BannerImg1 from "../../assets/img/banner-1.jpg";
import BannerImg2 from "../../assets/img/banner-2.jpg";
import BannerImg3 from "../../assets/img/banner-3.jpg";
import BannerImg4 from "../../assets/img/banner-4.jpg";

const bannerCarouselList = [
  {
    imgURL: BannerImg1,
    headText:
      "Elegant Stainless Steel Kitchen Units: Create a Timeless Culinary Space",
    paraText:
      "Sleek and modern design of stainless steel with the benefits of easy maintenance and superior durability.",
  },
  {
    imgURL: BannerImg2,
    headText: "Elevate Your Kitchen with Stylish Steel Sink Tables",
    paraText:
      "Made from high-quality stainless steel, these sink tables offer unmatched durability, resistance to stains, and easy maintenance.",
  },
  {
    imgURL: BannerImg3,
    headText: "Single Burner Gas Stoves for Compact Kitchens",
    paraText:
      "Engineered for efficiency and versatility, our gas stoves provide reliable performance in a sleek and space-saving design.",
  },
  {
    imgURL: BannerImg4,
    headText: "Sleek Steel Kitchen Tables",
    paraText:
      "Crafted with precision and built to last, our steel tables seamlessly combine contemporary aesthetics with practicality.",
  },
];

const AboutUs = () => {
  return (
    <div>
      <div className="app-home__bannerCarousel">
        <Carousel
          autoPlay={true}
          infiniteLoop={true}
          interval={5000}
          showStatus={false}
          showThumbs={false}
          showArrows={true}
          stopOnHover={false}
          animationHandler={"fade"}
          transitionTime={1500}
          useKeyboardArrows
        >
          {bannerCarouselList.map((listItem, itemIndex) => {
            return (
              <div key={`home__bannerCarousel-${itemIndex}`}>
                <img
                  src={listItem.imgURL}
                  className="bannerCarouselImg"
                  alt="banner carousel img"
                />
                <div className="carousel-info">
                  <Typography
                    variant="h2"
                    gutterBottom
                    className="carousel-info-headText"
                  >
                    {listItem.headText}
                  </Typography>
                  <Typography
                    variant="body1"
                    gutterBottom
                    className="carousel-info-paraText"
                  >
                    {listItem.paraText}
                  </Typography>

                  {/* <button>Explore More</button> */}
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
      {/* <div className="app-home__banner" id="about-us">
        <Grid
          container
          direction="row"
          alignItems="stretch"
          className="app-home__banner__gridContainer"
        >
          <Grid
            item
            xs={12}
            md={8}
            lg={9}
            xl={10}
            className="app-home__banner__grid"
          >
            <p className="app-home__bannerPara">
              <h1 className="brand-title">Jeeva Industries</h1>, an{" "}
              <strong>ISO 9001:2015</strong> certified industry established in
              the year 2004 is one of the experienced companies in{" "}
              <strong>
                <i>
                  CNC Laser cutting, CNC Bending and sheet metal fabrication
                </i>
              </strong>
              . We manufacture and export various types of sheet metal
              components (both MS and SS). With more than 2 decades of
              experience, we master ourselves in tailor-made designs of sheet
              metal components as per customer requirement. We also manufacture
              and supply wide range of{" "}
              <strong>
                <i>kitchen equipment's</i>
              </strong>{" "}
              to both wholesaler and retailer. We render our maximum effort to
              garner complete customer satisfication by achieving best quality,
              timely delivery of the product with competitive cost.
            </p>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            lg={3}
            xl={2}
            className="app-home__banner__grid"
          >
            <div className="appp-home__bannerCounts bannerCounts-deskView">
              <div className="bannerCounts-box">
                <div className="bannerCounts-content">
                  <p className="bannerCounts-count">20+</p>
                  <h2 className="bannerCounts-headText">Years of business</h2>
                </div>
                <div className="bannerCounts-content">
                  <p className="bannerCounts-count">150+</p>
                  <h2 className="bannerCounts-headText">Satisfied Customer</h2>
                </div>
                <div className="bannerCounts-content">
                  <p className="bannerCounts-count">50+</p>
                  <h2 className="bannerCounts-headText">
                    Successful SPM Projects
                  </h2>
                </div>
                <div className="bannerCounts-content">
                  <p className="bannerCounts-count">300+</p>
                  <h2 className="bannerCounts-headText">
                    Successful Fabrication Projects
                  </h2>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div> */}
      <div className="app-about-company-container">
        <h2 className="ourmission-headText">About us</h2>
        <p className="ourmission-paraText app-home__bannerPara">
          <h1 className="brand-title">Jeeva Industries</h1>, an{" "}
          <strong>ISO 9001:2015</strong> certified industry established in the
          year 2004 is one of the experienced companies in{" "}
          <strong>
            <i>
              CNC Laser cutting, CNC Bending, Sheet metal fabrication and
              Kitchen Equipments manufacturing
            </i>
          </strong>
          .
        </p>
        <p className="ourmission-paraText app-home__bannerPara">
          We manufacture and export various types of sheet metal components
          (both MS and SS). With more than 2 decades of experience, we master
          ourselves in tailor-made designs of sheet metal components as per
          customer requirement.
        </p>
        <p className="ourmission-paraText app-home__bannerPara">
          We also manufacture and supply wide range of kitchen equipment
          products such as Steam Line Equipment, Commercial Trolley, Commercial
          Kitchen Equipment's and many more widely used in restaurants, hotels,
          canteens and food joints to both wholesaler and retailer.
        </p>
        <p className="ourmission-paraText app-home__bannerPara">
          We render our maximum effort to garner complete customer satisfication
          by achieving best quality, timely delivery of the product with
          competitive cost. All our products are widely appreciated by the
          customers for their corrosion and abrasion resistance, dimensional
          accuracy, robust construction, low maintenance and longer functional
          life. We provide all our products in various sizes, shapes and designs
          at market leading price. We also provide customization facility to
          customers as per their requirement and specification.
        </p>
      </div>
      <div className="app-home__bannerWrapper">
        <div className="home__bannerCountsWrapper">
          <div className="appp-home__bannerCounts bannerCounts-mobileView">
            <div className="bannerCounts-box">
              <div className="bannerCounts-content">
                <p className="bannerCounts-count">20+</p>
                <h2 className="bannerCounts-headText">Years of business</h2>
              </div>
              <div className="bannerCounts-content">
                <p className="bannerCounts-count">150+</p>
                <h2 className="bannerCounts-headText">Satisfied Customer</h2>
              </div>
              <div className="bannerCounts-content">
                <p className="bannerCounts-count">50+</p>
                <h2 className="bannerCounts-headText">
                  Successful SPM Projects
                </h2>
              </div>
              <div className="bannerCounts-content">
                <p className="bannerCounts-count">300+</p>
                <h2 className="bannerCounts-headText">
                  Successful Fabrication Projects
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
